module.exports = __webpack_public_path__ + "static/media/image2.7bf6deef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Cafe/images/image2.jpg
// module id = 647
// module chunks = 0